import { useEffect, useState } from "react";
import BrandingAPI from "./BrandingAPI/BrandingAPI";
import { ApsAppContent } from "UserExperience/portal-vnext";
import { useHttpAPI } from "../../../../common/http/httpServiceAPI";
import { useHistory, useLocation } from "react-router";
import HeaderAPI from "./Header/HeaderAPI";

const BrandedContentAPI = ({ children }) => {

  const http = useHttpAPI();
  const location = useLocation();
  const history = useHistory();
  const [brandSettings, setBrandSettings] = useState(null);
  const [directionClass, setDirectionClass] = useState('nav-setting-is-forward');

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  let contextIdFromUrl = query.get('ContextId');

    useEffect(() => {
      if (history.action === 'POP') {
        setDirectionClass('nav-setting-is-back');
      } else {
        setDirectionClass('nav-setting-is-forward');
      }
    }, [location, history.action]);

    useEffect(() => {
      const loadBrandSettings = async() => {
        const results = await http.get('/brandAPI?contextId=' + contextIdFromUrl);
        setBrandSettings(results);
      };

        loadBrandSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])    


  return (
    brandSettings !== null ? (
    <ApsAppContent className={directionClass}>
      <BrandingAPI brandSettings={brandSettings} />
      <HeaderAPI
        brandLogoUrl={brandSettings?.logoFileUrl}
        brandName={brandSettings?.name}
      />    
      {children}
    </ApsAppContent>
    ) : null
  );
}

export default BrandedContentAPI;